import type { CosmicHeaderSection } from '@/lib/cms/cosmic/types/CosmicHeaderType'
import { renderSection } from '../../_shared/renderSection'

const DesktopMenuSubMenu = ({
  leftSection,
  rightSection,
}: {
  leftSection?: CosmicHeaderSection
  rightSection?: CosmicHeaderSection
}) => (
  <div className="w-screen max-w-7xl p-6">
    <div className="grid grid-cols-2">
      {leftSection && (
        <div className="p-5">{renderSection({ section: leftSection })}</div>
      )}
      {rightSection && (
        <div className="p-5">{renderSection({ section: rightSection })}</div>
      )}
    </div>
  </div>
)

export default DesktopMenuSubMenu
